import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        userInfo: null,
        permissionList: [],
        buttonPermissionList: [],
        activeMenu: null,
        noticeCount: 0,
        videoObj: null // 视频
    },
    getters: {
        userInfo: (state) => state.userInfo ||
            (sessionStorage.getItem("userInfo") ? JSON.parse(sessionStorage.getItem("userInfo")) : {}),
        menuList: (state, getters) => getters.userInfo.menus || [],
        authToken: (state, getters) => getters.userInfo.token || "",
        permissionList: (state) => state.permissionList && state.permissionList.length ? state.permissionList
            : sessionStorage.getItem("permissionList") ? JSON.parse(sessionStorage.getItem("permissionList")) : [],
        buttonPermissionList: (state) => state.buttonPermissionList && state.buttonPermissionList.length ? state.buttonPermissionList
            : sessionStorage.getItem("buttonPermissionList") ? JSON.parse(sessionStorage.getItem("buttonPermissionList")) : [],
        activeMenu: (state) => state.activeMenu ||
            (sessionStorage.getItem("activeMenu") ? JSON.parse(sessionStorage.getItem("activeMenu")) : {}),
        noticeCount: (state) => state.noticeCount ||
            (sessionStorage.getItem("noticeCount") ? Number(sessionStorage.getItem("noticeCount")) : 0),
        videoObj: (state) => state.videoObj || sessionStorage.getItem("videoObj") || ""
    },
    mutations: {
        // 标记登录用户信息
        updateUserInfo (state, info) {
            state.userInfo = info;
            sessionStorage.setItem("userInfo", JSON.stringify(info));
        },
        // 标记登录用户权限信息
        setPermissionList (state, menuList) {
            let permissionList = [];
            let buttonPermissionList = [];
            let loopMenu = (menu) => {
                menu.forEach(item => {
                    if (item.url) {
                        permissionList.push(item);
                    } else if (item.key) {
                        buttonPermissionList.push(item);
                    }
                    if (item.children && item.children.length) {
                        loopMenu(item.children);
                    } else if (item.buttons && item.buttons.length) {
                        loopMenu(item.buttons);
                    }
                });
            };
            if (menuList && menuList.length) {
                loopMenu(menuList);
            }
            state.permissionList = permissionList;
            sessionStorage.setItem("permissionList", JSON.stringify(permissionList));
            state.buttonPermissionList = buttonPermissionList;
            sessionStorage.setItem("buttonPermissionList", JSON.stringify(buttonPermissionList));
        },
        // 标记当前展开菜单
        updateActiveMenu (state, menu) {
            state.activeMenu = menu;
            sessionStorage.setItem("activeMenu", JSON.stringify(menu));
        },
        // 清除用户信息
        clearUserInfo (state) {
            state.userInfo = null;
            state.noticeCount = 0;
            sessionStorage.removeItem("userInfo");
            sessionStorage.removeItem("permissionList");
            sessionStorage.removeItem("activeMenu");
            sessionStorage.removeItem("noticeCount");
            sessionStorage.removeItem("videoChannel");
        },
        updateNotice (state, count) {
            state.noticeCount = count;
            sessionStorage.setItem("noticeCount", count);
        },
        updateVideoObj (state, obj) {
            state.videoObj = obj;
            sessionStorage.setItem("videoObj", obj);
        }
    },
    actions: {},
    modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js